export default function BillInfo({ title, value }) {
   return (
      <p className="grid grid-cols-2 gap-3">
         <span className="capitalize font-semibold">Bill {title}: </span>
         <span>{value}</span>
      </p>
   );
}
